var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 135,
    viewBox: "0 0 115 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_4511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9412 35.543C75.3089 36.5665 74.8662 37.7058 74.2509 38.6024C73.0652 40.3281 71.193 41.5347 69.152 42.0128C67.2273 42.4648 65.3213 41.135 65.0324 39.1851C63.4829 28.8005 62.7625 1.00482 51.9382 3.30587C48.2201 4.09779 47.3046 8.9427 47.5485 12.7193C48.3626 25.1547 53.2289 37.2949 61.2392 46.8727C66.2143 52.8196 72.8176 57.9783 80.5428 58.8561C88.2643 59.7302 96.9274 54.9973 98.2894 47.3807",
    stroke: "#F5CF70",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1003 19.1219C79.1354 22.3493 87.0069 18.752 87.8286 12.8425",
    stroke: "#F5CF70",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.319 50.6082C114.958 68.5982 112.733 90.3984 101.617 106.487C90.4996 122.58 70.8433 132.587 51.2433 131.78C31.4857 130.966 13.2327 118.721 2.83984 98.467",
    stroke: "#F5CF70",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5906 70.5631C39.1591 72.9613 40.2997 75.5686 42.3595 76.8873C44.4193 78.2059 47.2745 78.1573 49.2893 76.7677",
    stroke: "#F5CF70",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6087 100.869C54.6021 103.54 37.0243 106.905 26.4852 88.9415C23.6225 84.063 21.7916 72.7781 27.0442 66.8014C25.052 69.2294 20.8048 69.2705 18.7638 66.8873C16.7227 64.5041 17.4431 60.3353 20.167 58.7626C22.8909 57.1937 26.8792 58.6431 27.9447 61.5941C31.3852 53.3275 39.842 47.3769 48.8166 46.91C57.7912 46.4431 66.8258 51.4897 71.1105 59.3529C75.3952 67.2198 74.7086 77.5073 69.4184 84.7429",
    stroke: "#F5CF70",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5965 108.807C64.6455 107.182 62.8633 103.319 62.6082 100.869",
    stroke: "#F5CF70",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 98.467C2.83984 98.467 16.1104 111.706 24.6422 115.053C49.2848 124.724 61.3585 114.257 65.1292 110.559",
    stroke: "#F5CF70",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2246 83.5102C68.7539 85.7478 66.0863 87.1486 63.3999 87.0963C60.7173 87.044 58.106 85.5386 56.7215 83.245C56.3313 82.5988 56.0386 81.9002 55.7422 81.2054",
    stroke: "#F5CF70",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.156 100.693C64.5592 99.8754 65.8124 98.807 66.8404 97.5519C67.4369 96.8235 67.9697 95.9942 68.056 95.0566C68.1423 94.119 67.6583 93.0806 66.7616 92.7967C65.606 92.4268 64.3529 93.5886 64.3754 94.7951C64.3979 96.0017 65.3996 97.0327 66.5477 97.4212C67.6958 97.8097 68.9602 97.6715 70.1421 97.4062C71.3277 97.141 72.487 96.7488 73.6951 96.6292C74.9033 96.5097 76.2052 96.7077 77.1319 97.4921C78.5051 98.6539 78.6514 100.746 78.1937 102.483C77.0231 106.947 72.2994 110.193 67.6921 109.696",
    stroke: "#F5CF70",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_4511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 135,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshop);
export default __webpack_public_path__ + "static/media/workshop.37df1aab89fe136e70eeac7e0a922ac6.svg";
export { ForwardRef as ReactComponent };